import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog as MatDialog, MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) { }

  readonly DialogResponse = DialogResponse;

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
  }

  dialogRequires(type: DialogResponse): boolean {
    return ((this.data.type ?? ConfirmationType.YesNo) & type) === type;
  }
}

export interface ConfirmDialogData {
  text: string;
  type: ConfirmationType;
}

export enum DialogResponse {
  Yes = 1,
  No = 2,
  Ok = 4,
  Cancel = 8
}

export enum ConfirmationType {
  YesNo = 3, // 1 + 2
  YesNoCancel = 11, // 1 + 2 + 8
  OkCancel = 12 // 4 + 8
}
